<body>
  <div class="apply row" ngif=policyInfo>
    <div class="col-12 col-md-4">
      <div class="selected-policy-container" *ngIf="policyInfo != undefined && showSelectedPolicyContainer">
        <div class="selected-policy row" id="selected-policy">
          <div class="carrier-logo col-6 col-md-12">
            <img src="{{carrierLogo}}" />
          </div>
          <hr class="selected-policy-border" />
          <div class="policy-details col-6 col-md-12">
            <div class="premium no-gutters" id="premium">
              <span class="sign">$</span>
              <span class="dollars">{{policyInfo.MonthlyPremium | dollars}}</span>
              <span class="cents">{{policyInfo.MonthlyPremium | cents}}</span>
              <span class="payment-type">/month</span>
            </div>
            <div class="term-amount">
              <p>Coverage Amount:&nbsp;<span>{{policyInfo.FaceAmount | currency: 'USD' : 'symbol' : '1.0'}}</span></p>
              <p>Term Length:&nbsp;<span>{{policyInfo.CoverageLength}}&nbsp;Years</span></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="apply-text col-12 col-md-8">
      <p class="page-header">You're finished online!</p>
      <p class="info-header">Your policy isn't active just yet, click submit and a licensed eFinancial Agent will contact you to finalize your policy.</p>
      <div class="col-12">
        <form class="apply-form" id="apply-form" *ngIf="policyInfo != undefined">
          <div class="apply-form-box row">
            <div class="col-3 col-md-2 clipboard">
              <img src="../assets/icon_clipboard.svg" />
            </div>
            <div class="col-9 col-md-8 apply-info" id="apply-info">
              <p class="apply-info-name" id="apply-info-name">{{policyInfo.FirstName}} {{policyInfo.MiddleInitial}}
                {{policyInfo.LastName}}</p>
              <p class="apply-info-address" id="apply-info-address">{{policyInfo.City}}, {{policyInfo.State}}
                {{policyInfo.ZipCode}}</p>
              <p class="apply-info-address" id="apply-info-phone">{{policyInfo.PhoneNumber | phone}}</p>
            </div>
            <div class="col-3 col-md-2 edit-apply-info" id="edit-btns">
              <button type="button" class="btn btn-edit" (click)="onEditBtnClick()" id="apply-edit-btn">
                <img src="../assets/icon_edit.svg" />
                <span>  Edit</span>
              </button>
              <button type="button" class="btn btn-confirm confirm-top hidden" (click)="onConfirmBtnClick()"
                id="apply-confirm-btn">
                <img src="../assets/icon_checkmark.svg" />
                <span>Confirm</span>
              </button>
            </div>
            <div class="col-12 hidden" id="apply-edit-form">
              <div class="group">
                <label class="control-label col-12 col-md-4 apply-label" id="name-label">Name</label>
                <div class="col-12 col-md-5 apply-info-name">
                  <input class="form-control top-input white-background" id="firstName" name="firstName" placeholder="First Name"
                    value={{policyInfo.FirstName}} required />
                </div>
                <div class="col-6 col-md-3">
                  <input class="form-control top-input white-background" id="middleInitial" placeholder="MI" value={{policyInfo.MiddleInitial}}
                    #midInit />
                </div>
                <div class="col-12 offset-md-4 col-md-8">
                  <input class="form-control white-background" id="lastName" placeholder="Last Name" value={{policyInfo.LastName}} required />
                </div>
              </div>
              <div class="group">
                <label class="control-label col-12 col-md-4 apply-label" id="zip-label">Zip Code</label>
                <div class="col-6 offset-md-4 col-md-4">
                  <input class="form-control white-background" id="zip" placeholder="Zip Code" value={{policyInfo.ZipCode}} required />
                </div>
              </div>
              <div class="group">
                <label class="control-label col-12 col-md-4 apply-label" id="phone-label">Phone number</label>
                <div class="col-12 offset-md-3 col-md-5">
                  <input [phone]='phone' class="form-control white-background" id="phone" type="tel" placeholder="(   )   -"
                    value={{policyInfo.PhoneNumber}} required />
                </div>
              </div>
            </div>
            <div class="offset-4 col-4">
              <button type="button" class="btn btn-confirm confirm-bottom hidden" (click)="onConfirmBtnClick()"
                id="apply-confirm-btn-bottom">
                <img src="../assets/icon_checkmark.svg" />
                <span>Confirm</span>
              </button>
            </div>
          </div>
          <div class="email-input-row row">
            <label class="col-12 col-md-4 apply-label" id="email-label">
              Enter email address to finalize
            </label>
            <div class="col-12 offset-md-1 col-md-7">
              <input class="form-control" id="email" type="email" placeholder="Email" value={{policyInfo.EmailAddress}}
                required />
            </div>
          </div>

          <div class="rotating spinner" id="apply-spinner"></div>
        </form>
      </div>
    </div>
    <div class="col-12" style="text-align: center;">
      <button type="button" class="btn-primary btn-huge" id="apply-submit" (click)="onSubmitBtnClick()">
        <span>Submit</span>
      </button>
    </div>
  </div>
</body>
